import { useMutation } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { mutationFnPOST } from "api/tanStackQuery/helpers";
import { format } from "date-fns";
import { DayPlanTrackingStatus } from "features/CenterContent/RoleContent/Personellstyrer/DayPlanTrackings/types";
import { FC, useState } from "react";
import { createToast, DropsButton } from "shared/components/Spor";
import { useUserInfo } from "shared/hooks/useUserInfo";

type AcknowledgeManualRequest = {
  username: string;
  employeeId: string;
  date: string;
};

type Props = {
  status: DayPlanTrackingStatus;
  employeeId: string;
};

const DayPlanTrackingActionButton: FC<Props> = ({ status, employeeId }) => {
  const { email } = useUserInfo();

  const { mutate: setAcknowledgeManual, isPending: acknowledgeloading } =
    useMutation({
      mutationFn: (body: AcknowledgeManualRequest) =>
        mutationFnPOST<any, AcknowledgeManualRequest>(
          `${getBackendUrl()}/day-plan/trackings/${body.date}/${
            body.employeeId
          }/add-manual-acknowledgement?username=${body.username}`,
          body,
        ),
    });

  const { mutate: removeAcknowledgeManual, isPending: removeAckloading } =
    useMutation({
      mutationFn: (body: AcknowledgeManualRequest) =>
        mutationFnPOST<any, AcknowledgeManualRequest>(
          `${getBackendUrl()}/day-plan/trackings/${body.date}/${
            body.employeeId
          }/remove-manual-acknowledgement?username=${body.username}`,
          body,
        ),
    });

  const [successState, setSuccessState] = useState<boolean>(false);
  const [fadeState, setFadeState] = useState<boolean>(false);

  if (
    status === DayPlanTrackingStatus.SENT ||
    status === DayPlanTrackingStatus.RECEIVED
  ) {
    return (
      <DropsButton
        bg={successState ? "transparent !important" : undefined}
        variant={successState ? "ghost" : "tertiary"}
        size="xs"
        loading={acknowledgeloading}
        onClick={(e) => {
          e.stopPropagation();
          setAcknowledgeManual({
            username: email,
            date: format(new Date(), "yyyy-MM-dd"),
            employeeId,
          });
          setSuccessState(true);
          setTimeout(() => setFadeState(true), 800);
          setTimeout(() => {
            createToast({
              variant: "success",
              text: "Bekreftelse sendt",
              duration: 3000,
              // TODO Spor: This must be redone now that Spor has removed toast functionability
              /* buttonText: "Angre",
              onClick: () => {
                removeAcknowledgeManual({
                  username: email,
                  date: format(new Date(), "yyyy-MM-dd"),
                  employeeId,
                });
                setSuccessState(false);
                setFadeState(false);
              }, */
            });
          }, 1600);
        }}
        /**
         * This adds data-fade, which a parent component will recognize with
         * &:has(button[data-fade="true"]) to make the whole parent fade.
         * This is done in order to minimize state propagation
         */
        data-success={successState}
        data-fade={fadeState}
      >
        {successState ? "Bekreftet" : "Bekreft"}
      </DropsButton>
    );
  }
  if (status === DayPlanTrackingStatus.MANUAL) {
    return (
      <DropsButton
        variant="tertiary"
        size="xs"
        loading={removeAckloading}
        onClick={(e) => {
          e.stopPropagation();
          removeAcknowledgeManual({
            username: email,
            date: format(new Date(), "yyyy-MM-dd"),
            employeeId,
          });
        }}
      >
        Gjenåpne
      </DropsButton>
    );
  }

  return null;
};

export default DayPlanTrackingActionButton;
